import { CSSProperties, FC } from "react";
import { Text, TextSecond, Thumb } from "./DiscountProgress.styled";
import { useTranslation } from "../../hooks/useTranslation";

type Props = {
  style?: CSSProperties;
  className?: string;
  text?: string;
  value:string
};

export const DiscountProgress: FC<Props> = ({ style, className, text, value }) => {
  const { t } = useTranslation();

  return (
    <Thumb style={style} className={`${className}`}>
      <Text>{value}</Text>
      <TextSecond>
        {text ? text : t("yourDiscountAlready")}
      </TextSecond>
    </Thumb>
  );
};
